module.exports = __webpack_public_path__ + "static/media/c.1af76946.jpg";